import React from 'react';

import Input from 'components/Input';
import { TEXT_COMMON, TEXT_CREATE_SURVEY } from 'constants/string/texts';
import useCreateSurvey from 'hooks/useCreateSurvey';

const SurveyTitle = (props) => {
  const { form, viewOnly } = props;
  const { onSaveStep } = useCreateSurvey();

  if (viewOnly) {
    return (
      <>
        {(form?.values?.is_template || form?.values?.meta_data?.from_template) && (
          <div className="mb-8">
            <p className="text-black/85 font-bold flex items-start gap-1 break-all">
              <img className="mt-2" src={require('assets/resources/Required.svg').default} alt="required" width={7} height={7} />
              {TEXT_CREATE_SURVEY.TEMPLATE_TITLE}
            </p>
            <p className="text-black/85">{`${TEXT_COMMON.FV_TEMPLATE}${form?.values?.title}`}</p>
          </div>
        )}

        {form?.values?.is_template || form?.values?.meta_data?.from_template
          ? form?.values?.title && <p className="text-black-102 text-2xl font-bold">{TEXT_CREATE_SURVEY.CHILD_5_YEAR_OLD_CHECKUP_REPORT}</p>
          : form?.values?.title && <p className="text-black-102 text-2xl font-bold">{form?.values?.title}</p>}
        {form?.values?.description && <p className="mt-4 text-secondary-354 text-base font-normal">{form?.values?.description}</p>}

        {(form?.values?.is_template || form?.values?.meta_data?.from_template) && (
          <div className="mt-4">
            <p className="font-bold text-secondary-354">{TEXT_CREATE_SURVEY.SURE_ANSWER}</p>
            <p className="text-secondary-354">{TEXT_CREATE_SURVEY.SURVEY_CONFIGURATION}</p>
            <p className="text-secondary-354">{TEXT_CREATE_SURVEY.SURVEY_TIME}</p>
            <p className="text-secondary-354">{TEXT_CREATE_SURVEY.NEED_UPLOAD_VIDEO_AND_IMAGE}</p>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <Input
        id="survey-title"
        onChange={form?.handleChange}
        value={form?.values?.title}
        placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_ENTER_TITLE_SURVEY}
        invalid={form?.errors?.title}
        className="w-full"
        classNameInput={`w-full px-0 py-2 border-0 bg-transparent border-b border-dashed ${!form?.errors?.title && 'border-gray-102/65'} text-2xl font-bold focus:outline-none`}
        name="title"
        onBlur={() => onSaveStep(form?.values)}
      />
      <Input
        onChange={form?.handleChange}
        value={form?.values?.description}
        placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_ENTER_DESCRIPTION_SURVEY}
        invalid={form?.errors?.description}
        className="w-full !h-auto"
        classNameInput={`w-full px-0 py-2 border-0 bg-transparent border-b border-dashed ${!form?.errors?.description && 'border-gray-102/65'} text-base focus:outline-none mt-4`}
        name="description"
        onBlur={() => onSaveStep(form?.values)}
      />
    </>
  );
};

export default React.memo(SurveyTitle);
